<template>
  <div>
    <div v-show="!preview">
      <div class="d-flex flex-row-column justify-content-between">
        <div class="d-inline-block mb-2 mt-2">
          <span @click="emit('reset')" class="page-title">
            <router-link to="/lmt/deposit/create">Make a Deposit</router-link>
          </span>
          <img src="../../../assets/icons/iconNextPage.svg" class="mx-1" />
          <span class="page-title">
            <span v-if="balance && data.deposit_type_id==1" to="/lmt/deposit/create">{{ $t('agent_specific.choose_agent') }}</span>

            <a href="#" v-else @click="add_agents" to="/lmt/deposit/create">{{ $t('agent_specific.choose_agent') }}</a>
          </span>
          <img src="../../../assets/icons/iconNextPage.svg" class="mx-1" />
          <span class="page-title">Choose Transactions</span>
        </div>
        <span>
          <span v-if="0" class="input-width-160 r-width-100 d-inline-block mr-3">
            <md-field>
              <label for="filter">Used/Unused</label>
              <md-select v-on:input="filter($event)" name="filter" id="filter" v-model="used">
                <md-option value>Show All</md-option>
                <md-option value="1">Only Used</md-option>
                <md-option value="0">Only Unused</md-option>
              </md-select>
            </md-field>
          </span>
          <md-button
            :disabled="balance==0"
            v-on:click="add"
            class="md-primary md-raised c-primary mb-2 ml-0"
          >
            <template>Add for Deposit</template>
          </md-button>
        </span>
      </div>

      <hr class="mt-0" />
      <span class="d-inline-block ml-3 mr-2 gray-header">Available for Deposit:</span> $
      <span class="f-s-18" v-if="pagination">{{pagination.available_for_deposit}}</span>
      <span class="d-inline-block ml-5 mr-2 gray-header">Selected for Deposit:</span> $
      <span class="f-s-18">{{(balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</span>
      <hr class="mb-0" />
      <my-table
        object="id"
        @select="onSelect"
        @unselect="onUnselect($event)"
        :values="items"
        name="transactions"
        :setvalues="setvalues"
        transactions="true"
      />

      <pagination-deposit
        v-on:change="paginationChange($event)"
        v-on:change_per_page="changePerPage($event)"
        v-if="pagination && pagination.data"
        :meta="pagination.meta"
        :links="pagination.links"
        :per_page="per_page"
      />

      <empty-state v-if="!loading&&items.length==0" />
      <loading v-if="loading" />
    </div>
    <deposit-preview v-if="preview" :data="data" :items="getSelectedValue" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// mixin for loading data and state
import DataMixin from "../../../mixins/data";

import Preview from "./Preview";
import MyTable from "../../form/TableDeposit";
import PaginationDeposit from "../../PaginationDeposit";

export default {
  mixins: [DataMixin, Pagination],

  props: ["agent_id", "data"],

  components: { "deposit-preview": Preview, "my-table": MyTable, "pagination-deposit": PaginationDeposit },

  data() {
    return {
      per_page: 10,
      search_term: "",
      // url for loading data
      api_url: "/lmt/deposit/agent-transactions?agent_id=" + this.agent_id,
      page: 1,
      //IMPORTANT loaded data is stored in items
      items: [],
      filtered: false,
      details_data: {},
      selected_ids: [],
      balance: 0,
      mdSelectedValue: [],
      preview: 0,
      used: "",
      key: 0,
      setvalues: ""
    };
  },
  watch: {
    agent_id: function(nagent_id, oagent_id) {
      if (nagent_id != "" && nagent_id != oagent_id) {
        this.loadData();
      }
    }
  },
  computed: {
    getSelectedValue() {
      let arr = [];
      let arrid = [];
      this.mdSelectedValue.forEach(element => {
        if (
          this.selected_ids.includes(element.id) &&
          !arrid.includes(element.id)
        ) {
          arr.push(element);
          arrid.push(element.id);
        }
      });
      return arr;
    }
  },
  created() {
    if (this.agent_id != "") {
      this.loadData();
    }

    Event.$on("add-agents", data => {
      this.preview = 0;
      this.page = 1;
    });
    Event.$on("add-transactions", data => {
      this.preview = 0;
      this.page = 1;
    });
    Event.$on("data_loaded", data => {
      this.key++;
    });
    Event.$on("remove", data => {
      this.mdSelectedValue = this.mdSelectedValue.filter(
        item => item.id != data[0]
      );
      this.onSelect(this.mdSelectedValue);
    });
  },
  methods: {
    add_agents() {
      this.page = 1;
      this.per_page = 10;
      this.$router.push({
        path: this.$route.path,
        query: { ...this.$route.query, page: 1, per_page: 10 }
      });
      this.emit("add-agents");
    },
    onSelect(items) {
      this.mdSelectedValue = this.mdSelectedValue.concat(items);

      this.mdSelectedValue = this.mdSelectedValue.filter(
        (thing, index, self) => index === self.findIndex(t => t.id === thing.id)
      );

      this.selected_ids = [];
      let i = 0;
      this.balance = 0;
      this.mdSelectedValue.forEach(element => {
        if (!this.selected_ids.includes(element.id)) {
          this.selected_ids[i++] = element.id;
          this.balance += parseFloat(element.amount);
        }
      });
    },
    onUnselect(id) {
      this.mdSelectedValue = this.mdSelectedValue.filter(el => el.id != id);
      this.onSelect(this.mdSelectedValue);
    },
    add() {
      this.$router.replace(this.$route.path + "?page=1");
      this.preview = 1;
    },
    emit(e) {
      Event.$emit(e);
    },
    filter() {}
  }
};
</script>